export function createPointLayer (layerName: string, overrides: any) {
    return {
        id: `${layerName}`,
        source: layerName,
        type: 'symbol',
        interactive: true,
        layout: {
            'icon-image': '{icon}-15',
            'icon-allow-overlap': true,
            // 'icon-color': '#a90706',
            // 'text-field': '{title}',
            'text-font': ['Open Sans Semibold', 'Arial Unicode MS Bold'],
            'text-offset': [0, 0.6],
            'text-anchor': 'top',
            'visibility': 'none'
        },
        ...overrides
    };
}
